import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const recommendation = css(typography.effra18, {
  boxShadow: shadows.shadow80,
  padding: 16,
  position: 'relative',
  // Design exception for container on sm only
  [MediaQueries.sm]: {
    width: 'calc(100% - 32px)',
    margin: '32px 16px',
  },
  [MediaQueries.mdAndUp]: {
    marginBottom: 40,
    marginTop: 48,
    padding: '32px 32px 15px 32px',
    overflow: 'hidden', // Prevent slide from bleeding out of recommendation box
  },
  [MediaQueries.lgAndUp]: {
    padding: 32,
  },
});

export const recommendationAlternative = css({
  boxShadow: 'none',
  border: `1px solid ${colorsPalette.grey10}`,
  [MediaQueries.mdAndUp]: {
    marginBottom: 48,
    marginTop: 40,
  },
});

export const summaryWrapper = css({
  marginBottom: 32,

  [MediaQueries.lgAndUp]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: 0,
  },
});

export const summary = css({
  '.swiper-container': {
    marginTop: 16,
    position: 'relative',
  },

  '.swiper-container:after': {
    background: `linear-gradient(270deg, ${colorsPalette.white} 0%, rgba(255, 255, 255, 0) 100%)`,
    content: '""',
    height: '100%',
    position: 'absolute',
    right: 0,
    top: 0,
    width: 50,
    zIndex: 2,
  },
});

export const tags = css({
  fontSize: 0, // fights the space cause to inline elements
  marginBottom: 8,
});

export const tag = css(typography.effra12Link, {
  backgroundColor: colorsPalette.grey10,
  border: `1px solid ${colorsPalette.grey10}`,
  borderColor: colorsPalette.grey10,
  borderRadius: 2,
  color: colorsPalette.grey80,
  display: 'inline-block',
  fontWeight: fontWeights.medium,
  marginBottom: 8,
  marginRight: 8,
  padding: '2px 8px',
});

export const tagAlternate = css(typography.effra12Link, {
  backgroundColor: colorsPalette.white,
  borderColor: colorsPalette.grey20,
  color: colorsPalette.teal,
});

export const answer = css(typography.effra14, {
  alignSelf: 'flex-start',
  border: `1px solid ${colorsPalette.grey10}`,
  borderRadius: 4,
  padding: '5px 12px',
  position: 'relative',
  width: 'auto',
});

export const answerWithIcon = css({
  paddingLeft: 34,
});

export const answerIcon = css(typography.effra14, {
  fontSize: 16,
  left: 12,
  position: 'absolute',
  top: 2,
});

export const price = css(typography.effra28, {
  fontWeight: fontWeights.medium,
  marginTop: 24,
  [MediaQueries.mdAndUp]: {
    marginTop: 32,
  },
});

export const priceMessage = css(typography.effra16, {
  color: colorsPalette.grey60,
});

export const stickyBar = css({
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 24,
  textAlign: 'center',
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
    textAlign: 'start',
  },
});

export const pricesCta = css(typography.effra16, {
  padding: 0,
  backgroundColor: colorsPalette.transparent,
  border: 0,
  borderBottom: `1px solid ${colorsPalette.grey20} `,
  color: colorsPalette.grey60,
  cursor: 'pointer',
  [MediaQueries.lgAndUp]: {
    marginTop: 16,
  },
});

export const locations = css({
  [MediaQueries.lgAndUp]: {
    height: '100%',
  },
});
